import { useState } from "react";
import type { TopicComment } from "@/mocks/topicDetails";

export default function TopicComments({ comments }: { comments: TopicComment[] }) {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section aria-label="网友热评">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
          <i className="ri-chat-3-line"></i>
        </span>
        网友热评
      </h2>

      <ul className="mt-5 flex flex-col gap-4">
        {comments.map((comment, index) => {
          const isLiked = Boolean(liked[index]);
          return (
            <li
              key={comment.user}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {comment.user.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-label text-sm font-semibold text-foreground-900">
                    {comment.user}
                  </span>
                  <span className="text-xs font-label text-foreground-500">{comment.time}</span>
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{comment.content}</p>
              <div className="mt-3 flex items-center gap-4">
                <button
                  type="button"
                  onClick={() => toggleLike(index)}
                  aria-pressed={isLiked}
                  className={
                    isLiked
                      ? "flex cursor-pointer items-center gap-1.5 text-xs font-label font-medium text-primary-600"
                      : "flex cursor-pointer items-center gap-1.5 text-xs font-label text-foreground-500 transition-colors hover:text-primary-600"
                  }
                >
                  <i className={isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                  {comment.likes + (isLiked ? 1 : 0)}
                </button>
                <span className="flex items-center gap-1.5 text-xs font-label text-foreground-500">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}